import React from "react";
import "../../styles/live-subscriptions/live-page-toaster.css";
import {
  CallIcon,
  LocationIcon1,
  PersonIcon,
  EmailIcon,
} from "../../images/icons/icons";

const MemberBasicInfo = ({
  rowData,
  showCloseButton = false,
  onClose,
  customTitle = "Checked-In Member",
}) => {
  const mapMemberData = (memberData) => {
    if (!memberData) return null;

    return {
      name:
        memberData?.user_name ||
        memberData?.name ||
        memberData?.member_name ||
        "NA",

      mobile: memberData?.user_mobile || memberData?.mobile || "NA",

      email: memberData?.user_email || memberData?.email || "NA",

      gymName: memberData?.gym_name || "NA",

      checkinTime:
        memberData?.date_added || memberData?.checkin_date_time || "-",

      isRenewal: memberData?.is_renewal || 0,

      profile: memberData?.profile || null,

      coverImage: memberData?.cover_image || null,

      type: memberData?.type || "NA",

      // Trainer Info
      trainerName: memberData?.trainer_name || "NA",
      trainerMobile: memberData?.trainer_mobile || "NA",
      trainerEmail: memberData?.trainer_email || "NA",

      // PT Trial Info
      threeDayAssigned: memberData?.three_day_assigned || 0,
      threeDayDoneCount: memberData?.three_day_done_count || "0",
      threeDayStartDate: memberData?.threeday_start_date || null,
      threeDayExpireDate: memberData?.threeday_expire_date || null,

      // Subscription Info
      currentPlanName: memberData?.current_plan_name || "NA",
      currentPlanStatus: memberData?.current_plan_status || "NA",
      subscriptionExpiryDays: memberData?.subscription_expiry_days || "NA",
      currentSubscriptionStartDate:
        memberData?.current_subscription_start_date || null,
      currentSubscriptionExpireDate:
        memberData?.current_subscription_expire_date || null,

      // BCA Status
      bcaStatus: memberData?.bca_status || "NA",

      // Resolution Info
      isResolved: memberData?.is_resolved || 0,
      resolvedDate: memberData?.resolved_date || null,
      resolvedByName: memberData?.resolved_by_name || "NA",
      resolvedByMobile: memberData?.resolved_by_mobile || "NA",
      resolvedByEmail: memberData?.resolved_by_email || "NA",

      ...memberData,
    };
  };

  const mappedData = mapMemberData(rowData);

  if (!mappedData) return null;

  return (
    <div className="lp-member-basic-info-container">
      {showCloseButton && (
        <button className="lp-member-close-btn" onClick={onClose} title="Close">
          ×
        </button>
      )}

      <div className="lp-member-header">
        <div className="lp-member-header-main">
          <div className="lp-member-header-icon">
            {mappedData.profile ? (
              <img
                src={mappedData.profile}
                alt="Member Profile"
                className="lp-member-profile-image"
              />
            ) : (
              <PersonIcon color="#1f2937" />
            )}
          </div>
          <div className="lp-member-header-text">
            <h3 className="lp-member-header-title">{mappedData.name}</h3>
            <p className="lp-member-header-subtitle">{customTitle}</p>
          </div>
        </div>

        {(mappedData.isRenewal === 1 || mappedData.isRenewal === 0) && (
          <div className="lp-member-status-badge">
            <span className={`lp-badge lp-badge-fresh`}>
              {mappedData.isRenewal === 1
                ? "Existing Member"
                : mappedData.isRenewal === 0
                ? "Fresh Member"
                : "NA"}
            </span>
          </div>
        )}
      </div>

      <div className="lp-member-contact-grid">
        <div className="lp-member-contact-row">
          <div className="lp-member-contact-item">
            <CallIcon color="#1f2937" className="lp-member-contact-icon" />
            <span className="lp-member-contact-text">{mappedData.mobile}</span>
          </div>

          {mappedData.email && mappedData.email !== "NA" && (
            <div className="lp-member-contact-item">
              <EmailIcon color="#1f2937" className="lp-member-contact-icon" />
              <span className="lp-member-contact-text lowercase">{mappedData.email}</span>
            </div>
          )}
        </div>

        <div className="lp-member-gym-location">
          <LocationIcon1 color="#1f2937" className="lp-member-contact-icon" />
          <span className="lp-member-contact-text">{mappedData.gymName}</span>
        </div>
      </div>

      {/* Trainer Information */}
      {/* {mappedData.trainerName !== "NA" && (
        <div className="lp-member-info-section">
          <div className="lp-member-section-title">Trainer Information</div>
          <div className="lp-member-info-grid">
            <div className="lp-member-info-item">
              <PersonIcon color="#1f2937" className="lp-member-info-icon" />
              <span className="lp-member-info-text">
                {mappedData.trainerName}
              </span>
            </div>
            <div className="lp-member-info-item">
              <CallIcon color="#1f2937" className="lp-member-info-icon" />
              <span className="lp-member-info-text">
                {mappedData.trainerMobile}
              </span>
            </div>
          </div>
        </div>
      )} */}

      {/* Subscription Information */}
      {/* {(mappedData.currentPlanName !== "NA" ||
        mappedData.currentPlanStatus !== "NA" ||
        mappedData.currentSubscriptionStartDate ||
        mappedData.currentSubscriptionExpireDate ||
        mappedData.subscriptionExpiryDays !== "NA") && (
        <div className="lp-member-info-section">
          <div className="lp-member-section-title">Current Subscription</div>
          <div className="lp-member-info-grid">
            {mappedData.currentPlanName !== "NA" && (
              <div className="lp-member-info-item">
                <span className="lp-member-info-label">Plan:</span>
                <span className="lp-member-info-value">
                  {mappedData.currentPlanName}
                </span>
              </div>
            )}
            {mappedData.currentPlanStatus !== "NA" && (
              <div className="lp-member-info-item">
                <span className="lp-member-info-label">Status:</span>
                <span
                  className={`lp-member-status-badge ${
                    mappedData.currentPlanStatus === "active"
                      ? "lp-status-active"
                      : "lp-status-inactive"
                  }`}
                >
                  {mappedData.currentPlanStatus}
                </span>
              </div>
            )}
            {mappedData.currentSubscriptionStartDate &&
              mappedData.currentSubscriptionStartDate !== null && (
                <div className="lp-member-info-item">
                  <span className="lp-member-info-label">Start:</span>
                  <span className="lp-member-info-value">
                    {formatDateTime(mappedData.currentSubscriptionStartDate)}
                  </span>
                </div>
              )}
            {mappedData.currentSubscriptionExpireDate &&
              mappedData.currentSubscriptionExpireDate !== null && (
                <div className="lp-member-info-item">
                  <span className="lp-member-info-label">Expires:</span>
                  <span className="lp-member-info-value">
                    {formatDateTime(mappedData.currentSubscriptionExpireDate)}
                  </span>
                </div>
              )}
            {mappedData.subscriptionExpiryDays !== "NA" && (
              <div className="lp-member-info-item">
                <span className="lp-member-info-label">Days Left:</span>
                <span className="lp-member-info-value">
                  {mappedData.subscriptionExpiryDays}
                </span>
              </div>
            )}
          </div>
        </div>
      )} */}

      {/* PT Trial Information */}
      {/* {(mappedData.threeDayAssigned === 1 ||
        mappedData.threeDayDoneCount !== "0" ||
        mappedData.threeDayStartDate ||
        mappedData.threeDayExpireDate) && (
        <div className="lp-member-info-section">
          <div className="lp-member-section-title">PT Trial Status</div>
          <div className="lp-member-info-grid">
            <div className="lp-member-info-item">
              <span className="lp-member-info-label">Progress:</span>
              <span className="lp-member-info-value">
                {mappedData.threeDayDoneCount}/3 sessions
              </span>
            </div>
            <div className="lp-member-info-item">
              <span className="lp-member-info-label">Status:</span>
              <span
                className={`lp-member-status-badge ${
                  mappedData.threeDayDoneCount === "3"
                    ? "lp-status-completed"
                    : "lp-status-pending"
                }`}
              >
                {mappedData.threeDayDoneCount === "3"
                  ? "Completed"
                  : "In Progress"}
              </span>
            </div>
            {mappedData.threeDayStartDate &&
              mappedData.threeDayStartDate !== null && (
                <div className="lp-member-info-item">
                  <span className="lp-member-info-label">Start:</span>
                  <span className="lp-member-info-value">
                    {formatDateTime(mappedData.threeDayStartDate)}
                  </span>
                </div>
              )}
            {mappedData.threeDayExpireDate &&
              mappedData.threeDayExpireDate !== null && (
                <div className="lp-member-info-item">
                  <span className="lp-member-info-label">Expires:</span>
                  <span className="lp-member-info-value">
                    {formatDateTime(mappedData.threeDayExpireDate)}
                  </span>
                </div>
              )}
          </div>
        </div>
      )} */}

      {/* BCA Status */}
      {/* {mappedData.bcaStatus !== "NA" && (
        <div className="lp-member-info-section">
          <div className="lp-member-section-title">BCA Status</div>
          <div className="lp-member-info-grid">
            <div className="lp-member-info-item">
              <span
                className={`lp-member-status-badge ${
                  mappedData.bcaStatus === "completed"
                    ? "lp-status-completed"
                    : "lp-status-pending"
                }`}
              >
                {mappedData.bcaStatus}
              </span>
            </div>
          </div>
        </div>
      )} */}

      {/* Resolution Information */}
      {/* {mappedData.isResolved === 1 && (
        <div className="lp-member-info-section lp-member-resolution-section">
          <div className="lp-member-section-title">Resolution Details</div>
          <div className="lp-member-info-grid">
            <div className="lp-member-info-item">
              <span className="lp-member-info-label">Resolved By:</span>
              <span className="lp-member-info-value">
                {mappedData.resolvedByName}
              </span>
            </div>
            <div className="lp-member-info-item">
              <span className="lp-member-info-label">Date:</span>
              <span className="lp-member-info-value">
                {formatDateTime(mappedData.resolvedDate)}
              </span>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default MemberBasicInfo;
